import api from 'api'
import type { CompanyDetail } from 'api/company/companyDetail'

type EditGeneralInfoRequest = {
  type?: CompanyDetail['type']
  requiresEverify?: boolean
  terminalTierThresholdHours?: number
  terminalTierThresholdDirection?: 'after_shift_create' | 'before_shift_start'
  pastShiftCreationAllowed?: boolean
}

export const editGeneralInfo = async (
  companyId: number,
  request: EditGeneralInfoRequest
): Promise<void> => {
  const response = await api.patch(`/admin/company/${companyId}`, {
    type: request.type,
    requires_everify: request.requiresEverify,
    terminal_tier_threshold_hours: request.terminalTierThresholdHours,
    terminal_tier_threshold_direction: request.terminalTierThresholdDirection,
    past_shift_creation_allowed: request.pastShiftCreationAllowed,
  })
  return response.data
}
